// 项目公共方法配置
export default {
	install: function(Vue, options) {
		// 使用minxin将功能注入所有组件
		Vue.mixin({
            data(){
                return {}
            },
            computed:{
                // url配置
                urlConfig(){
                    return require('@/config/index.js')
                }
            },
			methods: {
                // 差异比较
                equarData(a, b, onGetArr){
                    // 差异判断，不比较字段
                    let equarFilter =  onGetArr?onGetArr:['newData','valRwa','getapi_id','sorting','parent_id','leaf','user_id','user_action_id','actionWait','lock','lock_user_id'];

                    // 好像不用特殊比较，暂时保留
                    // if(a){
                    //     a = this.deepCopy(a)
                    //     if(typeof a.url != 'undefined'){
                    //         a.url = this.urlInit(a.url)
                    //     }else{
                    //         a.request.url = this.urlInit(a.request.url)
                    //     }
                    // }

                    // if(b){
                    //     b = this.deepCopy(b)
                    //     if(typeof b.url != 'undefined'){
                    //         b.url = this.urlInit(b.url)
                    //     }else{
                    //         b.request.url = this.urlInit(b.request.url)
                    //     }
                    // }

                    return this.equar(a, b, equarFilter)
                },

                /*********** Url地址操作 ***********/
                // 净化请求地址
                urlInit(url){
                    url = url.split(/[?#]/)
                    return url[0]
                },
                // 域名获取
                getHost(url) {
                	var host = "null";
                	if (typeof url == "undefined" ||
                		null == url)
                		url = window.location.href;
                	var regex = /.*\:\/\/([^\/]*).*/;
                	var match = url.match(regex);
                	if (typeof match != "undefined" &&
                		null != match)
                		host = match[1];
                	return host;
                },
                // 获取域名源
                getOrigin(url) {
                	var host = "null";
                	if (typeof url == "undefined" ||
                		null == url)
                		url = window.location.href;
                	var regex = /(http|https)\:\/\/([^\/]*).*/;
                	var match = url.match(regex);
                	if (typeof match != "undefined" &&
                		null != match)
                		host = match[1]+'://'+match[2];
                	return host;
                },

                /*********** 用户级缓存设置-浏览器 ***********/
                getUserCache(name){
                    let user = JSON.parse(this.getCache('user'))
                    return this.getCache(user.action_id+"_"+name);
                },
                setUserCache(name,val){
                    let user = JSON.parse(this.getCache('user'))
                    return this.setCache(user.action_id+"_"+name,val);
                },
                detUserCache(name,val){
                    let user = JSON.parse(this.getCache('user'))
                    return this.delCache(user.action_id+"_"+name,val);
                },

                /*********** 用户级缓存设置-应用 ***********/
                // 获取缓存数据
                getUserECache(name){
                    let user = JSON.parse(this.getCache('user'))
                	return this.getECache(user.action_id+"_"+name);
                },
                // 设置缓存数据
                setUserECache(name, val, isBrowser = true){
                    let user = JSON.parse(this.getCache('user'))
                	return this.setECache(user.action_id+"_"+name, val, isBrowser);
                },
                detUserECache(name,val){
                    let user = JSON.parse(this.getCache('user'))
                    return this.delECache(user.action_id+"_"+name,val);
                },

                /*********** 优化限制操作 ***********/
                // 判断项目是否达到加载时间
                isloadTime(){
                    return this.getNowTime()-this.$store.state.runTimeList[this.getapiId] >= 60 * 3 * 1000
                },
                // 项目切换冷却时间
                isSwitchRun(){
                    // console.log(this.getNowTime()-this.$store.state.switchTimeList);
                    // console.log(this.$store.state.switchInitRunEnd);
                    return this.getNowTime()-this.$store.state.switchTimeList > 1000 && this.$store.state.switchInitRunEnd
                },

                /*********** 用户 ***********/
                // 获取用户信息
                getUser(){
                    return JSON.parse(this.getCache('user'))
                },
                // 设置用户信息
                setUser(data){
                    let user = this.getUser();
                        user = Object.assign(user,data);
                    this.setCache('user',JSON.stringify(user));
                    this.$store.state.user = user;
                },

                // 获取用户配置
                getUserConfig(){
                    let user = this.getUser()
                    return user && this.isJsonStr(user['app_config'])?JSON.parse(user['app_config']):undefined
                },
                // 设置用户配置
                setUserConfig(config){
                    let user = this.getUser()
                    if(user){
                        user['app_config'] = JSON.stringify(config)
                        this.setCache("user", JSON.stringify(user));
                    }
                },

                // 获取用户项目配置
                getUserProjectConfig(getapiId){
                    getapiId = getapiId?getapiId:this.getapiId;
                    let projectUser = this.getUserCache(getapiId+"_"+'projectUser');
                    return projectUser?JSON.parse(projectUser):undefined
                },
                // 设置用户项目配置
                setUserProjectConfig(data,getapiId){
                    getapiId = getapiId?getapiId:this.getapiId;
                    let userProject = this.getUserProjectConfig(getapiId)
                        userProject = userProject?userProject:{};
                        userProject = Object.assign(userProject,data)
                    this.setUserCache(getapiId+"_"+'projectUser',JSON.stringify(userProject));
                },

                // 清除用户数据
                clearUserData(){
                    this.delCache('token');
                    this.delCache('toppingList');
                    this.delCache('user');
                    this.delCache('projectList');
                    this.delCache('project');
                    // localStorage.clear();
                    this.delCacheAll(['editableTabsValue','editableTabs','processTotalList'])

                    this.delCookie('token');
                    this.delCookie('project');
                    this.$store.state.projectList = [];
                    this.$store.state.projectIsInit = false;
                    this.$store.state.runTimeList = [];
                },

                /*********** 公共方法 ***********/
                // 数据遍历公共方法
                loopData(menuData,func){
                    let arr = []
                    for (var now of menuData) {
                        let runObj = func(now)
                        if(runObj){
                            if (now && now.node) {
                            	runObj.node = this.loopData(now.node,func);
                            }
                            arr.push(runObj)
                        }
                    }
                    return arr
                },
                // 重置响应模块大小
                responseResize(){
                    let main = document.querySelector('.w-main-content')
                    let mainHeight = main?main.clientHeight:0;
                    let header = document.querySelector('.w-main-content-header')
                    let headerHeight = header?header.clientHeight:0;

                    this.$store.state.editorHeight = main - headerHeight

                    if(this.$store.state.menuTypeActive=='dev'){
                        this.$store.state.editorHeight -= 41
                    }else{
                        let detailsManageHeight = document.querySelector('.w-details-manage').clientHeight
                        if(detailsManageHeight!=0){
                            this.$store.state.editorHeight = detailsManageHeight
                        }
                        // // 左右布局判断
                        // if(!this.$store.state.layoutAboutMode){
                        //     this.$store.state.editorHeight -= 41
                        // }
                    }
                },
				// 大小转换(B)
                sizeChange(bytes) {
                    if (bytes === 0) return '0 B';
                    var k = 1024;
                    var sizes = ['B','KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
                    var i = Math.floor(Math.log(bytes) / Math.log(k));

                    var num = bytes / Math.pow(k, i);
                    return num.toPrecision(3) + ' ' + sizes[i];

                    //return (bytes / Math.pow(k, i)) + ' ' + sizes[i];
                    //toPrecision(3) 后面保留一位小数，如1.0GB //return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
                },

                // 获取body类型
                getBodyType(typeStr){
                    let type = typeStr.split('/')[1]
                    if(type=='plain'){
                        return 'text'
                    }
                    return type;
                },
                // body类型 键值对判断
                isFormTypeKeyVal(formType){
                	return !formType || formType=='multipart/form-data' || formType=='application/x-www-form-urlencoded'
                },
                
			},
		});
	}
};
